export default {
    REG_PHONE: /^1([358][0-9]|4[579]|66|7[0135678]|9[189])[0-9]{8}$/,  // 手机号
}